import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './TablaProducto.module.css';
import { v4 as uuidv4 } from 'uuid';
import Tooltip from '@mui/material/Tooltip';
import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
} from "reactstrap";
import ModalCamposObligatorios from '../../../App/ModalCamposObligatorios'
import {
    obtenerColoniasPorCpApi, obtenerCPsPorMunicipioApi, obtenerEstadosApi,
    obtenerLocalidadesPorEstadoYMunicipioApi, obtenerCallesPorClavesEstadoMunicipioLocalidad,
    obtenerEstadosConClaveApi, obtenerMunicipiosConClavePorEstadoApi
} from '../../../../redux/DucksApis/CopomexDucks';
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../../redux/AppDucks'

function TablaProductoPredio(props) {

    const dispatch = useDispatch()
    const { api = undefined } = props
    const marcas = props.marcas
    let fc_36DomiciliosMap = props.productosMap
    const emicioncertificadopromocion = props.emicioncertificadopromocion
    const { handdleDomiclio, handdleRemoveDomicilioPrev, handdleEditDomicilioPrev,
        domicilio, handdleDomicilioFiscalBaja/*, handdleDomicilioFiscalAlta, handdleDomicilioFiscalSucursal*/ } = api
    // const { predioMap, handdleDomiclioMap } = props.Mappredio
    const [id, setId] = React.useState()
    const [estado, setestado] = React.useState('')
    const [municipio, setmunicipio] = React.useState('')
    const [codigopostal, setcodigopostal] = React.useState('')
    const [colonia, setcolonia] = React.useState('')
    const [localidad, setlocalidad] = React.useState('')
    const [calle, setcalle] = React.useState('')
    const [otracalle, setotracalle] = React.useState('')
    const [numeroexterior, setnumeroexterior] = React.useState('')
    const [numerointerior, setnumerointerior] = React.useState('')
    const [domicilioprincipal, setdomicilioprincipal] = React.useState(false)

    const estadosApi = useSelector(store => store.CopomexApi.estados)
    const municipiosApi = useSelector(store => store.CopomexApi.municipios)
    const codigosPostalesApi = useSelector(store => store.CopomexApi.codigosPostales)
    const coloniasApi = useSelector(store => store.CopomexApi.colonias)
    const localidadesApi = useSelector(store => store.CopomexApi.localidades)
    const callesApi = useSelector(store => store.CopomexApi.calles)

    const [editar, setEditar] = React.useState(false)

    const [productoMap, setproductoMap] = React.useState()

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    let columns = [

        {
            field: 'domicilio', headerName: 'Domicilio Completo', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex:1,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.domicilio}`} arrow>
                        <label>{`${params.row.domicilio} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'domicilioprincipal', headerName: 'Tipo Domicilio', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex:.4,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.domicilioprincipal ? 'Domicilio Fiscal' : 'Sucursal'}`} arrow>
                        <label>{`${params.row.domicilioprincipal ? 'Domicilio Fiscal' : 'Sucursal'} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex:.4,
            renderCell: (params) => (

                <Fragment>
                    {params.row.baja === null ?
                        <Fragment>
                            {fc_36DomiciliosMap?.length > 0 ? (
                                <Fragment>
                                    <button className={'btn btn-danger ms-1'} onClick={() => { botonCorregir(params) }} >Corregir</button>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>
                                    <button className={'btn btn-danger ms-1'} onClick={() => { botonEliminar(params) }} >Eliminar</button>
                                    {/*<button className={params.row.domicilioprincipal == false ? 'btn btn-outline-success ms-1' : 'btn btn-success ms-1'} onClick={() => { botonSucursalDomicilio(params) }} >{params.row.domicilioprincipal == false ? 'sucursal' : 'Domicilio Fiscal'}</button>*/}
                                </Fragment>
                            )}
                        </Fragment>
                        : ((params.row.baja === false || params.row.baja === true) && params.row.isbaja === false) ?
                            <Fragment>
                                <button className={params.row.baja === false ? `btn btn-outline-warning ms-1` : params.row.baja === true ? `btn btn-danger ms-1` : ''} onClick={() => { botonBaja(params.row) }} >Dar de Baja</button>
                                {/*params.row.baja === false && <button className={params.row.domicilioprincipal == false ? 'btn btn-outline-success ms-1' : 'btn btn-success ms-1'} onClick={() => { botonSucursalDomicilio(params) }} >{params.row.domicilioprincipal == false ? 'sucursal' : 'Domicilio Fiscal'}</button>*/}
                            </Fragment> : ''
                        /*<Fragment>
                            <button className={(params.row.baja === false && params.row.alta === false) ? `btn btn-outline-warning ms-1` : (params.row.baja === false && params.row.alta === true) ? `btn btn-success ms-1` : ''} onClick={() => { botonAlta(params.row) }} >Dar de Alta</button>
                            {params.row.baja === false && params.row.alta === true &&
                                <button className={params.row.domicilioprincipal == false ? 'btn btn-outline-success ms-1' : 'btn btn-success ms-1'} onClick={() => { botonSucursalDomicilio(params) }} >{params.row.domicilioprincipal == false ? 'sucursal' : 'Domicilio Fiscal'}</button>
                            }
                        </Fragment>*/
                    }
                </Fragment>

            )
        },
    ]
    const [DomicilioFicalPrincipal, setDomicilioFicalPrincipal] = React.useState(false)

    React.useEffect(async () => {
        await dispatch(actualizarLoadingApp_true())
        const result = await obtenerEstadosConClave()
        await cargarDomicilioApi(result)
        await dispatch(actualizarLoadingApp_false())

    }, [])

    const cargarDomicilioApi = async (estadosConClave) => {
        var municipiosConClave = []
        if (estado !== '') {
            const result = await dispatch(obtenerMunicipiosConClavePorEstadoApi(estado))
            municipiosConClave = result.payload
        }
        if (municipio !== '') {
            const result = await dispatch(obtenerCPsPorMunicipioApi(municipio))
        }
        if (codigopostal !== '') {
            //codigopostal
            const result = await dispatch(obtenerColoniasPorCpApi(codigopostal))
        }
        var localidadesConClave = []
        if (codigopostal !== '') {
            const result = await dispatch(obtenerLocalidadesPorEstadoYMunicipioApi({ estado: estado, municipio: municipio }))
            localidadesConClave = result.payload
        }
        if (localidad !== '') {
            const clave_estado = await obtenerClaveDomicilioEstado(estadosConClave, estado)
            const clave_municipio = await obtenerClaveDomicilio(municipiosConClave, municipio, "municipio")
            const clave_localidad = await obtenerClaveDomicilio(localidadesConClave, localidad, "localidad")
            const result = await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({ clave_estado: clave_estado, clave_municipio: clave_municipio, clave_localidad: clave_localidad }))

        }
    }
    const obtenerEstadosConClave = async () => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerEstadosConClaveApi())
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerMunicipiosConClave = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerMunicipiosConClavePorEstadoApi(data))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerCodigosPostales = async (municipio) => {
        //get Codigos Postales por municipio
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerCPsPorMunicipioApi(municipio))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerColonias = async (cp) => {
        //get colonia por CP
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerColoniasPorCpApi(cp))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerLocalidades = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerLocalidadesPorEstadoYMunicipioApi({ estado: data.estado, municipio: data.municipio }))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }

    const obtenerCalles = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const clave_estado = await obtenerClaveDomicilioEstado(estadosApi, data.clave_estado)
        const clave_municipio = await obtenerClaveDomicilio(municipiosApi, data.clave_municipio, "municipio")
        const clave_localidad = await obtenerClaveDomicilio(localidadesApi, data.clave_localidad, "localidad")
        const result = await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({ clave_estado: clave_estado, clave_municipio: clave_municipio, clave_localidad: clave_localidad }))
        await dispatch(actualizarLoadingApp_false())
        // await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({clave_estado: data.clave_estado, clave_municipio: data.clave_municipio, clave_localidad: data.clave_localidad}))
        return result.payload
    }
    const obtenerClaveDomicilioEstado = async (array, key) => {
        for (const i in array) {
            if (array[i][0] === key) return array[i][1]
        }
    }
    const obtenerClaveDomicilio = async (array, key, nombre) => {
        for (const i in array) {
            if (array[i][nombre] === key) return array[i]["clave"]
        }
    }

    const botonEliminar = async (params) => {
        handdleRemoveDomicilioPrev({ data: params.row })
    }
    /*const botonSucursalDomicilio = async (params) => {
        handdleDomicilioFiscalSucursal({ data: params.row })
    }*/
    const botonGuardar = async () => {

        let numexterior = ''
        let numinterior = ''
        let calleOtro = ''
        let col = ''
        if (numeroexterior === '') numexterior = 's/n'
        else { numexterior = numeroexterior }
        if (numerointerior === '') numinterior = 's/n'
        else { numinterior = numerointerior }
        if (colonia === '') col = 'Sin colonia'
        else { col = colonia }
        if (calle === 'Otro') calleOtro = otracalle
        else calleOtro = calle

        let tipodomicilio = false
        if (domicilioprincipal == 'domicilioFiscal') tipodomicilio = true
        else tipodomicilio = false
        let dato = {
            id: id, domicilio: calleOtro + ', ' + numexterior + ', ' + numinterior + ', ' +
                col + ', ' + localidad + ', ' + municipio + ', ' + estado + ', ' + codigopostal,
            calle: calle, numerointerior: numerointerior, numeroexterior: numeroexterior,
            colonia: colonia, localidad: localidad, municipio: municipio, estado: estado,
            codigopostal: codigopostal, otracalle: calleOtro,
            alta: true, baja: null, isbaja: false, domicilioprincipal: tipodomicilio
        }
        handdleEditDomicilioPrev(dato)
        setestado('')
        setmunicipio('')
        setlocalidad('')
        setcolonia('')
        setcalle('')
        setnumeroexterior('')
        setnumerointerior('')
        setcodigopostal('')
        setdomicilioprincipal('')
        setEditar(false)
        setproductoMap([])
    }
    const botonEditar = async (params) => {
        setId(params.row.id)
        //let domicilio = params.row.domicilio.split(';')
        setestado(params.row.estado)
        setmunicipio(params.row.municipio)
        setcodigopostal(params.row.codigopostal)
        setcolonia(params.row.colonia)
        setlocalidad(params.row.localidad)
        setcalle(params.row.calle)
        setnumerointerior(params.row.numerointerior)
        setnumeroexterior(params.row.numeroexterior)
        let tipo = ''
        if (params.row.domicilioprincipal) tipo = 'domicilioFiscal'
        else tipo = 'sucursal'
        setdomicilioprincipal(tipo)
        /*const result = await obtenerEstadosConClave()
        await cargarDomicilioApi(result)*/
        setEditar(true)
    }

    let datos = []
    let [rows, setRows] = React.useState(domicilio)
    React.useEffect(() => {
        setRows(domicilio)
        let filtro = domicilio.filter(anexo => anexo.domicilioprincipal == true)
        if (filtro.length == 0) {
            setDomicilioFicalPrincipal(true)
        }
    }, [domicilio])

    const botonAgregar = async () => {
        if (estado.toString().length > 0 && municipio.length > 0 && localidad.length > 0 && domicilioprincipal.length != '') {
            let numexterior = ''
            let numinterior = ''
            let col = ''
            let calleOtro = ''
            if (calle === 'Otro') calleOtro = otracalle
            else calleOtro = calle
            if (numeroexterior === '') numexterior = 's/n'
            else { numexterior = numeroexterior }
            if (numerointerior === '') numinterior = 's/n'
            else { numinterior = numerointerior }
            if (colonia === '') col = 'Sin colonia'
            else { col = colonia }
            let tipodomicilio = false
            if (domicilioprincipal == 'domicilioFiscal') tipodomicilio = true
            else tipodomicilio = false
            let dato = {
                id: uuidv4(), domicilio: calleOtro + ', ' + numexterior + ', ' + numinterior + ', ' +
                    col + ', ' + localidad + ', ' + municipio + ', ' + estado + ', ' + codigopostal,
                calle: calle, numerointerior: numerointerior, numeroexterior: numeroexterior,
                colonia: colonia, localidad: localidad, municipio: municipio, estado: estado,
                codigopostal: codigopostal, otracalle: calleOtro,
                alta: true, baja: null, isbaja: false, domicilioprincipal: tipodomicilio
            }
            handdleDomiclio(dato)
            setestado('')
            setmunicipio('')
            setlocalidad('')
            setcolonia('')
            setcalle('')
            setnumeroexterior('')
            setnumerointerior('')
            setdomicilioprincipal('')
            setcodigopostal('')
        } else {
            setvalidacion(true)
        }
    }
    const botonCancelar = async () => {
        setproductoMap([])
        setestado('')
        setmunicipio('')
        setlocalidad('')
        setcolonia('')
        setcalle('')
        setcodigopostal('')
        setnumeroexterior('')
        setnumerointerior('')
        setdomicilioprincipal('')
        setEditar(false)
    }
    const botonCorregir = async (params) => {
        await dispatch(actualizarLoadingApp_true())
        const filtro = fc_36DomiciliosMap.filter(anexo => anexo?.idfc36_anexodomiciliosfiscales === params.row.idfc36_anexodomiciliosfiscales)
        setproductoMap(filtro[0])
        if (params.row.idfc36_anexodomiciliosfiscales) setId(params.row.idfc36_anexodomiciliosfiscales)
        else setId(params.row.idfc36_anexodomiciliosfiscales)
        setestado(params.row.estado)
        //await cargarDomicilioApi()
        await dispatch(obtenerMunicipiosConClavePorEstadoApi(params.row.estado))
        await setmunicipio(params.row.municipio)
        await dispatch(obtenerCPsPorMunicipioApi(params.row.municipio))
        await setcodigopostal(params.row.codigopostal)
        await dispatch(obtenerColoniasPorCpApi(params.row.codigopostal))
        setcolonia(params.row.colonia)
        await dispatch(obtenerLocalidadesPorEstadoYMunicipioApi({ estado: params.row.estado, municipio: params.row.municipio }))
        setlocalidad(params.row.localidad)
        //await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({ clave_estado: clave_estado, clave_municipio: clave_municipio, clave_localidad: clave_localidad }))
        setcalle(params.row.calle)
        setnumerointerior(params.row.numerointerior)
        setnumeroexterior(params.row.numeroexterior)
        let tipo = ''
        if (params.row.domicilioprincipal) tipo = 'domicilioFiscal'
        else tipo = 'sucursal'
        setdomicilioprincipal(tipo)
        setEditar(true)
        await dispatch(actualizarLoadingApp_false())
    }
    const botonBaja = async (params) => {
        handdleDomicilioFiscalBaja(params)
    }
    /*const botonAlta = async (params) => {
        handdleDomicilioFiscalAlta(params)
    }*/
    return (
        <>
            <FormGroup>
                <div className='row align-items-center'>

                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <div className="form-floating mb-3">
                            <select className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                value={estado}
                                onChange={e => {
                                    setestado(e.target.value)
                                    setmunicipio('')
                                    setcodigopostal('')
                                    setlocalidad('')
                                    setcalle('')
                                    setnumeroexterior('')
                                    setnumerointerior('')
                                    if (e.target.value !== '') obtenerMunicipiosConClave(e.target.value)

                                }} name="estado" >
                                <option value="">Seleccione su estado</option>
                                {estadosApi?.[0] !== undefined && estadosApi?.map((estado, index) => (
                                    <option key={index} value={`${estado[0]}`}>{`${estado[0]}`}</option>))
                                }
                            </select>
                            <span className={` ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck ? 'text-danger' : 'text-success') : ('')}`} >
                                {productoMap?.validacioncheck ? (productoMap?.observacion) : ''}</span>
                            <label className='floatingInput'>Estado</label>
                        </div>
                    </div>
                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <div className="form-floating mb-3">
                            <select className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                value={municipio}
                                onChange={e => {
                                    setmunicipio(e.target.value)
                                    setcodigopostal('')
                                    setcolonia('')
                                    setlocalidad('')
                                    setcalle('')
                                    setnumeroexterior('')
                                    setnumerointerior('')
                                    if (e.target.value !== '') obtenerCodigosPostales(e.target.value)
                                }}
                                name="municipio" disabled={estado === '' ? true : false} >
                                <option value="">Seleccione su municipio</option>
                                {municipiosApi?.[0] !== undefined && municipiosApi?.map((municipio, index) => (
                                    <option key={index} value={`${municipio.municipio}`}>{`${municipio.municipio}`}</option>
                                ))}
                            </select>
                            <span className={` ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'text-danger' : 'text-success') : ('')}`} >{productoMap?.validacioncheck ? (productoMap?.observacion) : ''}</span>
                            <label className="label-dark" htmlFor="floatingInput">Municipio/Alcaldía</label>
                        </div>
                    </div>
                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <div className="form-floating mb-3">
                            <select className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                value={codigopostal}
                                onChange={e => {
                                    setcodigopostal(e.target.value)
                                    setcolonia('')
                                    setlocalidad('')
                                    setcalle('')
                                    setnumeroexterior('')
                                    setnumerointerior('')
                                    if (e.target.value !== '') obtenerColonias(e.target.value)
                                    if (e.target.value !== '') obtenerLocalidades({ estado: estado, municipio: municipio })
                                }}
                                name="codigopostal" disabled={municipio === '' ? true : false} >
                                <option value="">Seleccione su código postal</option>
                                {codigosPostalesApi?.[0] !== undefined && codigosPostalesApi?.map((cp, index) => (
                                    <option key={index} value={`${cp}`}>{`${cp}`}</option>
                                ))}
                            </select>
                            <span className={` ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'text-danger' : 'text-success') : ('')}`} >{productoMap?.validacioncheck ? (productoMap?.observacion) : ''}</span>
                            <label className="label-dark" htmlFor="floatingInput">Código Postal</label>
                        </div>
                    </div>
                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <div className="form-floating mb-3">
                            <select className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                value={colonia}
                                onChange={e => {
                                    setcolonia(e.target.value)
                                    setlocalidad('')
                                    setcalle('')
                                    setnumeroexterior('')
                                    setnumerointerior('')
                                }} name="colonia" disabled={codigopostal === '' ? true : false} >
                                <option value="">Seleccione su colonia</option>
                                {coloniasApi?.[0] !== undefined && coloniasApi?.map((colonia, index) => (
                                    <option key={index} value={`${colonia}`}>{`${colonia}`}</option>))
                                }
                            </select>
                            <span className={` ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'text-danger' : 'text-success') : ('')}`} >{productoMap?.validacioncheck ? (productoMap?.observacion) : ''}</span>
                            <label className="label-dark" htmlFor="floatingInput">Colonia</label>
                        </div>
                    </div>
                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <div className="form-floating mb-3">
                            <select className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                value={localidad}
                                onChange={e => {
                                    setlocalidad(e.target.value)
                                    setcalle('')
                                    setnumeroexterior('')
                                    setnumerointerior('')
                                    if (e.target.value !== '') obtenerCalles({ clave_estado: estado, clave_municipio: municipio, clave_localidad: localidad })
                                }} name="localidad" disabled={codigopostal === '' ? true : false}>
                                <option value="">Seleccione su localidad</option>
                                {localidadesApi?.[0] !== undefined && localidadesApi?.map((localidad, index) => (
                                    <option key={index} value={`${localidad.localidad}`}>{`${localidad.localidad}`}</option>
                                ))
                                }
                            </select>
                            <span className={` ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'text-danger' : 'text-success') : ('')}`} >{productoMap?.validacioncheck ? (productoMap?.observacion) : ''}</span>
                            <label className="label-dark" htmlFor="floatingInput">Localidad</label>
                        </div>
                    </div>
                    <div className={`col-xs-12 col-sm-12 ${calle === 'Otro' ? 'col-md-1 col-lg-1 col-xl-1' : 'col-md-6 col-lg-6 col-xl-6'}`}>
                        <div className="form-floating mb-3">
                            <select className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                value={calle}
                                onChange={e => {
                                    setcalle(e.target.value)
                                    setnumeroexterior('')
                                    setnumerointerior('')
                                }} name="calle" disabled={localidad === '' ? true : false} >
                                <option value="">Seleccione su calle</option>
                                {callesApi?.[0] !== undefined && callesApi?.map((calle, index) => (
                                    <option key={index} value={`${calle.nombre_vialidad}`}>{`${calle.nombre_vialidad}`}</option>
                                ))}
                                <option value="Otro">Otro</option>
                            </select>
                            <span className={` ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'text-danger' : 'text-success') : ('')}`} >{productoMap?.validacioncheck ? (productoMap?.observacion) : ''}</span>
                            <label className="label-dark" htmlFor="floatingInput">Calle</label>
                        </div>
                    </div>
                    {calle === 'Otro' &&
                        <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput"
                                    className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                        ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    placeholder='Calle'
                                    name="otracalle" value={otracalle}
                                    onChange={e => {
                                        setotracalle(e.target.value)
                                    }}
                                />
                                <span className={` ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                    ? 'text-danger' : 'text-success') : ('')}`} >{productoMap?.validacioncheck ? (productoMap?.observacion) : ''}</span>
                                <label className="label-dark" htmlFor="floatingInput">Especifique</label>
                            </div>
                        </div>
                    }
                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <div className="form-floating mb-3">
                            <input type="text" id="floatingInput"
                                className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                placeholder='Número exterior'
                                name="numeroexterior" value={numeroexterior}
                                onChange={e => {
                                    setnumeroexterior(e.target.value)
                                }} />
                            <span className={` ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'text-danger' : 'text-success') : ('')}`} >{productoMap?.validacioncheck ? (productoMap?.observacion) : ''}</span>
                            <label className="label-dark" htmlFor="floatingInput">Número exterior</label>
                        </div>
                    </div>
                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <div className="form-floating mb-3">
                            <input type="text" className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                id="" placeholder='Número interior'
                                name="numerointerior" value={numerointerior}
                                onChange={e => { setnumerointerior(e.target.value) }} />
                            <span className={` ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'text-danger' : 'text-success') : ('')}`} >{productoMap?.validacioncheck ? (productoMap?.observacion) : ''}</span>
                            <label className="label-dark" htmlFor="floatingInput">Número interior</label>
                        </div>
                    </div>
                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <div className="form-floating mb-3">
                            <select className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                value={domicilioprincipal}
                                onChange={e => { setdomicilioprincipal(e.target.value) }} name="domicilioprincipal" >
                                <option value="">Seleccione su domicilio</option>
                                <option value='domicilioFiscal'>Domicilio Fiscal</option>
                                <option value="sucursal">Sucursal</option>
                            </select>
                            <span className={` ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck ? 'text-danger' : 'text-success') : ('')}`} >
                                {productoMap?.validacioncheck ? (productoMap?.observacion) : ''}</span>
                            <label className='floatingInput'>Tipo de domicilio</label>
                        </div>
                    </div>
                </div>
            </FormGroup>
            {!editar ?
                <Fragment>
                    {fc_36DomiciliosMap?.length === 0 ? (
                        <Fragment>
                            <div className='col-md-3'></div>
                            <div className='text-center'>
                                <button className='btn btn-success col-md-3' onClick={botonAgregar}>Agregar</button>
                            </div>
                            <span className='text-start'><b className='text-danger'>Nota:</b>Si desea agregar una sucursal o domicilio fiscal tildar botón Agregar Sucursal.</span>
                            <br />
                        </Fragment>) : ''}
                </Fragment>
                : (
                    <Fragment>
                        <div className='row'>
                            <div className='col-md-3'></div>
                            <button className={'btn btn-success col-md-3 ms-0'} onClick={botonGuardar}>Guardar domiclio</button>
                            <button className={'btn btn-dark col-md-3 ms-2'} onClick={botonCancelar}>Cancelar</button>
                        </div>
                        <br />
                    </Fragment>
                )}
            <br />
            <hr />
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
            <div className='row justify-content-center'>
                <div className='col-12'>
                    <div style={{ height: (130 + (rows?.length * 50)), width: '103%', color: 'black' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}

                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />
                    </div>
                </div>
            </div>
            {DomicilioFicalPrincipal && <div className="text-danger">Seleccionar el domicilio Fiscal</div>}
        </>
    )

}
export default TablaProductoPredio